module.exports = __webpack_public_path__ + "img/wp.3a8dad7f.png";